import { useEffect, useState } from "react";
import { api, formatApiError } from "@/lib/api";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Button } from "@/components/ui/button";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { toast } from "sonner";
import CaseLogList from "@/components/admin/CaseLogList";

export default function CaseLogsPanel() {
  const [techs, setTechs] = useState([]);
  const [techId, setTechId] = useState("all");
  const [from, setFrom] = useState("");
  const [to, setTo] = useState("");
  const [logs, setLogs] = useState([]);

  useEffect(() => {
    api.get("/admin/technicians").then((r) => setTechs(r.data)).catch(() => {});
  }, []);

  useEffect(() => {
    const params = new URLSearchParams();
    if (techId !== "all") params.set("technician_id", techId);
    if (from) params.set("date_from", from);
    if (to) params.set("date_to", to);
    api.get(`/admin/case-logs?${params.toString()}`)
      .then((r) => setLogs(r.data))
      .catch((e) => toast.error(formatApiError(e.response?.data?.detail)));
  }, [techId, from, to]);

  return (
    <div className="soft-card p-6">
      <div className="flex items-end justify-between mb-4 flex-wrap gap-3">
        <div className="font-display text-xl font-bold">All case logs <span className="text-sm font-normal text-slate-500">({logs.length})</span></div>
        <div className="flex items-end gap-3 flex-wrap">
          <div>
            <Label className="text-xs">Technician</Label>
            <Select value={techId} onValueChange={setTechId}>
              <SelectTrigger data-testid="caselogs-filter-tech" className="w-48 border border-slate-200 h-10 mt-1"><SelectValue /></SelectTrigger>
              <SelectContent>
                <SelectItem value="all">All technicians</SelectItem>
                {techs.map((t) => <SelectItem key={t.id} value={t.id} data-testid={`caselogs-filter-tech-${t.id}`}>{t.name}</SelectItem>)}
              </SelectContent>
            </Select>
          </div>
          <div>
            <Label className="text-xs">From</Label>
            <Input data-testid="caselogs-filter-from" type="date" value={from} onChange={(e) => setFrom(e.target.value)} className="border border-slate-200 h-10 mt-1" />
          </div>
          <div>
            <Label className="text-xs">To</Label>
            <Input data-testid="caselogs-filter-to" type="date" value={to} onChange={(e) => setTo(e.target.value)} className="border border-slate-200 h-10 mt-1" />
          </div>
          <Button data-testid="caselogs-filter-clear" variant="outline" onClick={() => { setTechId("all"); setFrom(""); setTo(""); }} className="border border-slate-200 h-10">
            Clear
          </Button>
        </div>
      </div>
      <CaseLogList logs={logs} />
    </div>
  );
}
